<template>
  <HorizontalCarousel :items="items" :options="options">
      <template v-slot="{ item }">
        <CourseThumbBox
          :course="item"
          class="course-thumb-box"
        >
          <BaseBadge
            class="primary outline"
          >Aulas grátis disponíveis!</BaseBadge>
        </CourseThumbBox>
      </template>
    </HorizontalCarousel>
</template>

<script>
import HorizontalCarousel from '@/components/carousel/HorizontalCarousel'
import CourseThumbBox from '@/components/course/CourseThumbBox'
import BaseBadge from '@/components/badges/BaseBadge'

export default {
  components: {
    HorizontalCarousel,
    CourseThumbBox,
    BaseBadge     
  },
  
  props: {
    items: {
      type: Array, required: true,
    }
  },

  data: () => ({   
    options: {
      arrows: true
    }
  }),
  
};
</script>

<style scoped lang="scss">
  .img-carousel {
    border-radius: 8px;
    max-width: 100%;
    width: auto;
  }
</style>